// A3 Form Constants

// Field Labels
export const FIELD_LABELS = {
  TITLE: 'Title',
  INDUSTRIAL_ENGINEER: 'Industrial Engineer',
  SITE_DC: 'Site/DC',
  REGION: 'Region',
  STATUS: 'Status',
  DATE: 'Date',
  VALIDATED_SAVINGS: 'Validated Savings ($, optional)',
  TAGS: 'Tags (comma-separated)',
  BACKGROUND: 'Background',
  PROBLEM_STATEMENT: 'Problem Statement',
  DESCRIPTION: 'Description',
  METRIC_1: 'Metric 1',
  METRIC_1_UNFAVORABLE: 'Metric 1 Unfavorable',
  METRIC_2: 'Metric 2 (optional)',
  METRIC_2_UNFAVORABLE: 'Metric 2 Unfavorable',
  GOAL_STATEMENT: 'Goal Statement',
  TARGET_METRIC: 'Target Metric',
  TARGET_DATE: 'Target Date',
  CAUSE: 'Cause',
  CATEGORY: 'Category',
  EVIDENCE: 'Evidence',
  COUNTERMEASURE: 'Countermeasure',
  LINKED_CAUSE: 'Linked Cause',
  OWNER: 'Owner',
  ACTION: 'Action',
  DUE_DATE: 'Due Date',
  LESSON: 'Lesson',
  CAUSE_ROW: 'Cause Row',
  COUNTERMEASURE_ROW: 'Countermeasure Row',
  ACTION_ROW: 'Action Row',
  LESSON_ROW: 'Lesson Row',
  RESULTS_SUMMARY: 'Results Summary'
};

// Section Headings
export const SECTION_HEADINGS = {
  PROJECT_INFO: 'Project Info',
  DEFINE_PROBLEM: 'Define the Problem',
  CURRENT_STATE: 'Current State',
  GOAL_TARGET_STATE: 'Goal / Target State',
  CAUSE_ANALYSIS: 'Cause Analysis',
  COUNTERMEASURES: 'Countermeasures',
  ACTION_PLAN: 'Action Plan',
  RESULTS_LESSONS: 'Results & Lessons Learned'
};

// Dropdown Options
export const DROPDOWN_OPTIONS = {
  REGION: ['West', 'East'],
  STATUS: ['Not Started', 'In Progress', 'Completed']
};

// Placeholders
export const PLACEHOLDERS = {
  TITLE: 'e.g. Reduce Outbound Trailer Detention Time - Tracy, CA DC',
  SITE_DC: 'eg: Tracy, CA',
  TAGS: 'e.g. Detention, Loading',
  DATE: 'e.g. 17-Aug-2026',
  VALIDATED_SAVINGS: 'e.g. 50000',
  BACKGROUND: "Context - why does this matter, what's the setting?",
  PROBLEM_STATEMENT: "What's wrong, how big is the gap, since when?",
  DESCRIPTION: 'How does the process work today?',
  GOAL_STATEMENT: 'What does success look like?',
  TARGET_METRIC: 'e.g. Target: < 1.0 hr avg detention',
  TARGET_DATE: 'e.g. 30-Sep-2026',
  METRIC_1: 'e.g. 2.3 hrs avg detention',
  METRIC_2: 'e.g. $38,400 in fees',
  RESULTS_SUMMARY: 'What happened after the countermeasures went live?'
};

// Empty State Messages
export const EMPTY_STATE_MESSAGES = {
  EMPTY: '(empty)',
  NOT_DOCUMENTED: 'Not documented',
  NO_CAUSES: 'No causes yet — add the root causes behind the problem.',
  NO_COUNTERMEASURES: 'No countermeasures yet.',
  NO_ACTIONS: 'No actions yet.',
  NO_LESSONS: 'No lessons yet.',
  NO_CAUSES_LOGGED: 'No causes logged yet.',
  NO_COUNTERMEASURES_LOGGED: 'No countermeasures logged yet.',
  NO_ACTIONS_LOGGED: 'No actions logged yet.',
  SAVINGS_NOT_RECORDED: 'Savings not yet recorded',
  NO_A3_FORMS_FOUND: 'No A3 Forms Found.'
};

// Button Labels
export const BUTTON_LABELS = {
  ADD_CAUSE: 'Add Cause',
  ADD_COUNTERMEASURE: 'Add Countermeasure',
  ADD_ACTION: 'Add Action',
  ADD_LESSON: 'Add Lesson',
  SAVE_A3: 'Save A3',
  CANCEL: 'Cancel',
  REFRESH: 'Refresh Form'
};

// UI Text
export const UI_TEXT = {
  EDIT_A3: 'Edit A3',
  NEW_A3: 'New A3',
  THIS_A3: 'this A3',
  EDITING: 'Editing',
  EDITING_SAVE_MESSAGE: ' — changes save back into A3 Repository.',
  NEW_A3_INSTRUCTION: 'Fill in the sections below — switch to Live Preview to see the finished A3.',
  DRAFT_PREVIEW_SUBTITLE: 'A3 Problem-Solving Report — Draft Preview',
  BACKGROUND_LABEL: 'Background:',
  ANNUALIZED_SAVINGS: 'Annualized Savings'
};

// Status Badge Classes
export const STATUS_CLASSES = {
  COMPLETED: 'completed',
  IN_PROGRESS: 'inprogress',
  NOT_STARTED: 'notstarted'
};

// CSS Classes
export const CSS_CLASSES = {
  CAUSE_ROW: 'cause-row',
  COUNTER_ROW: 'counter-row',
  ACTION_ROW: 'action-row',
  LESSON_ROW: 'lesson-row'
};

// Grid Templates
export const GRID_TEMPLATES = {
  ACTION_PLAN: '2fr 1fr 1fr 1fr',
  RESULTS_LESSONS: '2fr 1fr',
  DEFAULT: '2fr 1fr 2fr'
};

// API Parameter Keys
export const API_KEYS = {
  A3_ID: 'a3Id',
  USER_ID: 'userId',
  NAME: 'name',
  TITLE: 'title',
  INDUSTRIAL_ENGINEER: 'industrialEngineer',
  SITE_DC: 'siteDc',
  REGION: 'region',
  STATUS: 'status',
  DATE: 'date',
  VALIDATED_SAVINGS: 'validatedSavings',
  TAGS: 'tags',
  DEFINE_PROBLEM: 'defineProblem',
  CURRENT_STATE: 'currentState',
  GOAL_TARGET_STATE: 'goalTargetState',
  CAUSE_ANALYSIS: 'causeAnalysis',
  COUNTERMEASURES: 'countermeasures',
  ACTION_PLAN: 'actionPlan',
  RESULTS_LESSONS_LEARNED: 'resultsAndLessonsLearned',
  RESULTS_SUMMARY: 'resultsSummary',
  LESSONS_LEARNED: 'lessonsLearned',
  BACKGROUND: 'background',
  PROBLEM_STATEMENT: 'problemStatement',
  DESCRIPTION: 'description',
  METRIC_1: 'metric1',
  METRIC_2: 'metric2',
  GOAL_STATEMENT: 'goalStatement',
  TARGET_METRIC: 'targetMetric',
  TARGET_DATE: 'targetDate',
  CAUSE: 'cause',
  CATEGORY: 'category',
  EVIDENCE: 'evidence',
  COUNTERMEASURE: 'countermeasure',
  LINKED_CAUSE: 'linkedCause',
  OWNER: 'owner',
  ACTION: 'action',
  DUE_DATE: 'dueDate',
  LESSON: 'lesson'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  SAVED: 'A3 form saved successfully.',
  UPDATED: 'A3 form updated successfully.',
  DELETED: 'A3 form deleted.'
};

// Error Messages
export const ERROR_MESSAGES = {
  LOAD_FAILED: 'Failed to load A3 for editing.',
  LOAD_FORMS_FAILED: 'Failed to load A3 forms.',
  DELETE_FAILED: 'Failed to delete the A3 form.',
  EXPORT_FAILED: 'Export failed: ',
  EXPORT_ERROR: 'Export error: ',
  UNKNOWN_ERROR: 'Unknown Error',
  MISSING_FIELDS: 'Please fill in all required fields: '
};

// Month abbreviations for date formatting
export const MONTH_ABBREVIATIONS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Required fields list
export const REQUIRED_FIELDS = [
  FIELD_LABELS.TITLE,
  FIELD_LABELS.INDUSTRIAL_ENGINEER,
  FIELD_LABELS.SITE_DC,
  FIELD_LABELS.REGION,
  FIELD_LABELS.STATUS,
  FIELD_LABELS.DATE,
  FIELD_LABELS.TAGS
];

// Preview Title
export const PREVIEW_SUBTITLE = 'A3 Problem-Solving Report — Draft Preview';

// Default Values
export const DEFAULT_VALUES = {
  GUEST_USER: 'GuestUser',
  UNTITLED_A3: 'Untitled A3',
  DEFAULT_REGION: 'West',
  DEFAULT_STATUS: 'Not Started'
};